import React from "react";

const basf = React.createContext(false);

export default basf;
